import Navbar from 'src/components/NavBar';
import ViewInvoiceContextProvider from 'src/sections/view_invoices/ViewInvoiceContext';
import ViewInvoiceTable from 'src/sections/view_invoices/ViewInvoiceTable';

function ViewInvoices() {
  return (
    <ViewInvoiceContextProvider>
      <Navbar title="View Invoices/Credits" />
      <ViewInvoiceTable />
    </ViewInvoiceContextProvider>
  );
}

export default ViewInvoices;
